export default {
  choose_preferred_wallet: "کیف پول مورد نظر خود را انتخاب کنید",
  connect_mobile_wallet: "به کیف پول موبایل وصل شوید",
  scan_qrcode_with_wallet: "کد QR را با یک کیف پول سازگار با WalletConnect اسکن کنید",
  return_to_mobile_options: "به گزینه های کیف پول موبایل برگردید",
  view_qrcode_option: "مشاهده کد QR",
  connect: "اتصال",
};
